var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"action-page"},[_c('div',{staticClass:"action-page__skinxs-icon icon-universkin-logo"}),(_vm.shouldShowMessage)?_c('div',[_c('div',{staticClass:"text--level-1"},[_vm._v(_vm._s(_vm.level1Text))]),_c('div',{staticClass:"text--level-2"},[_vm._v(_vm._s(_vm.level2Text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }